import React, { useState } from 'react';
import {
    AppBar,
    Toolbar,
    Typography,
    IconButton,
    Drawer,
    List,
    ListItem,
    ListItemText,
    Menu,
    MenuItem,
    Box,
    Accordion,
    AccordionSummary,
    AccordionDetails,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import AccountCircle from '@mui/icons-material/AccountCircle';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import HelpIcon from '@mui/icons-material/Help';
import DashboardIcon from '@mui/icons-material/Dashboard';
import SecurityIcon from '@mui/icons-material/Security';
import { useAuth } from '../Auth/AuthProvider';
import { useNavigate } from 'react-router-dom';
import { getusercompanies, getuserdata, getusermenu, logoutAPI } from '../Conections/LogConections';
import { empresaAPI } from '../Conections/EmpresaConection';
import Display from './Display';



export default function DashboardInterface() {

    const auth = useAuth();
    const goTo = useNavigate();

    const [anchorEl, setAnchorEl] = useState(null);
    const [leftDrawerOpen, setLeftDrawerOpen] = useState(false);
    const [rightDrawerOpen, setRightDrawerOpen] = useState(false);
    const [expandedAccordion, setExpandedAccordion] = useState('');

    const [menuItems, setMenuItems] = React.useState([]);

    const [name, setName] = React.useState(null);
    const [logo, setLogo] = React.useState("");
    const [color, setColor] = React.useState("");
    const [company, setCompany] = React.useState("");
    const [companies, setCompanies] = React.useState(null);

    React.useEffect(() => {
        if (!auth.getToken()) {
            goTo("/login");
        }
        else {
            reloaduser();
        }
    }, []);

    async function changeCompany(companyid) {
        const company = await empresaAPI(auth.getToken(), companyid);
        setLogo(company.datos_base64);
        setCompany(company.name);
        setColor(company.color);
        setRightDrawerOpen(!rightDrawerOpen);
        auth.saveCompany(companyid);
        changeMenu(companyid);
        goTo("/dashboard");
    }

    async function changeMenu(companyid) {
        const menu = await getusermenu(auth.getToken(), companyid);
        var result = Object.keys(menu).map((key) => [key, menu[key]]);
        var menuDe = [];
        for (var i = 0; i < result.length; i++) {
            var item = [];
            for (var j = 0; j < result[i][1]["permission"].length; j++) {
                item[j] = [result[i][1]["permission"][j]["name"], result[i][1]["permission"][j]["page"]];
            }
            menuDe[i] = {
                title: result[i][1]["name"],
                icon: result[i][1]["icon"],
                items: item
            };
        }
        setMenuItems(menuDe);
    }

    const reloaduser = async () => {
        if (auth.getToken()) {
            const datos = await getuserdata(auth.getToken());
            setName(datos.name);

            const datosc = await getusercompanies(auth.getToken());
            setCompanies(datosc);

            if (auth.getCompany()) {
                const company = await empresaAPI(auth.getToken(), auth.getCompany());
                setLogo(company.datos_base64);
                setCompany(company.name);
                setColor(company.color);
                changeMenu(auth.getCompany());
            }
            else {
                const company = await empresaAPI(auth.getToken(), datosc[0][0]);
                auth.saveCompany(datosc[0][0]);
                setLogo(company.datos_base64);
                setCompany(company.name);
                setColor(company.color);
                changeMenu(datosc[0][0]);
            }
        }
    }

    function logoutFunction() {
        logoutAPI(auth.getToken());
        auth.saveAuth(false);
        auth.deleteToken();
        auth.deleteCompany();
        goTo("/login");
    }

    function iconSections(iconid) {
        if (iconid !== null) {
            switch (parseInt(iconid)) {
                case 1:
                    return <SecurityIcon />;
                case 2:
                    return <DashboardIcon />;
                default:
                    return <HelpIcon />;
            }
        }
    }


    const handleLeftDrawerToggle = () => {
        setLeftDrawerOpen(!leftDrawerOpen);
    };

    const handleRightDrawerToggle = () => {
        setRightDrawerOpen(!rightDrawerOpen);
    };

    const handleMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleAccordionChange = (panel) => (event, isExpanded) => {
        setExpandedAccordion(isExpanded ? panel : '');
    };

    const display = (
        <Box sx={{ display: 'flex' }}>
            <AppBar position="fixed" sx={{ backgroundColor: color, zIndex: (theme) => theme.zIndex.drawer + 1 }}>
                <Toolbar>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        edge="start"
                        onClick={handleLeftDrawerToggle}
                        sx={{ mr: 2 }}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
                        <img
                            src={`data:image/jpeg;base64,${logo}`}
                            alt={"Imagen"}
                            width={100}
                            loading="lazy"
                        />
                        <Typography variant="h6" noWrap component="div">
                            {company}
                        </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Typography variant="subtitle1" sx={{ mr: 2 }}>
                            {name}
                        </Typography>
                        <IconButton
                            size="large"
                            aria-label="account of current user"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleMenu}
                            color="inherit"
                        >
                            <AccountCircle />
                        </IconButton>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorEl}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            open={Boolean(anchorEl)}
                            onClose={handleClose}
                        >
                            <MenuItem onClick={handleClose}>Profile</MenuItem>
                            <MenuItem onClick={handleClose}>My account</MenuItem>
                            <MenuItem onClick={logoutFunction}>Logout</MenuItem>
                        </Menu>
                    </Box>
                    {companies
                        && companies.length > 1
                        ? (<IconButton
                            color="inherit"
                            aria-label="open right drawer"
                            edge="end"
                            onClick={handleRightDrawerToggle}
                        >
                            {rightDrawerOpen ? <ChevronRightIcon /> : <ExpandMoreIcon />}
                        </IconButton>
                        ) : (
                            <></>
                        )
                    }
                </Toolbar>
            </AppBar>
            <Drawer
                variant="temporary"
                open={leftDrawerOpen}
                onClose={handleLeftDrawerToggle}
                ModalProps={{
                    keepMounted: true, // Better open performance on mobile.
                }}
                sx={{
                    width: 240,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: 240,
                        boxSizing: 'border-box',
                    },
                }}
            >
                <Toolbar />
                <Box sx={{ overflow: 'auto' }}>
                    {menuItems.map((item, index) => (
                        <Accordion
                            key={item.title}
                            expanded={expandedAccordion === `panel${index}`}
                            onChange={handleAccordionChange(`panel${index}`)}
                        >
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls={`panel${index}bh-content`}
                                id={`panel${index}bh-header`}
                            >
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    {iconSections(item.icon)}
                                    <Typography sx={{ ml: 1 }}>{item.title}</Typography>
                                </Box>
                            </AccordionSummary>
                            <AccordionDetails>
                                <List>
                                    {item.items.map((subItem) => (
                                        <ListItem button key={subItem[0]}>
                                            <ListItemText primary={subItem[0]} onClick={() => (goTo(subItem[1]))} />
                                        </ListItem>
                                    ))}
                                </List>
                            </AccordionDetails>
                        </Accordion>
                    ))}
                </Box>
            </Drawer>
            <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
                <Toolbar />
                <Display />
            </Box>
            {companies
                && companies.length > 1
                ? (
                    <Drawer
                        variant="persistent"
                        anchor="right"
                        open={rightDrawerOpen}
                        sx={{
                            width: 240,
                            flexShrink: 0,
                            '& .MuiDrawer-paper': {
                                width: 240,
                                boxSizing: 'border-box',
                            },
                        }}
                    >
                        <Toolbar />

                        <Box sx={{ overflow: 'auto' }}>
                            <List>
                                {companies.map((companyMap) => (
                                    <ListItem button key={companyMap[0]}>
                                        <ListItemText
                                            primary={companyMap[1]}
                                            onClick={() => (
                                                changeCompany(companyMap[0])
                                            )}
                                        />
                                    </ListItem>
                                ))
                                }
                            </List>
                        </Box>

                    </Drawer>
                ) : (
                    <></>
                )
            }
        </Box>
    );

    return display;
}
